import React from "react";
import { Check } from "lucide-react";

const RSVPSection = ({
  isOriginator,
  isEditing,
  selectedEvent,
  getCurrentUserRSVPStatus,
  t,
  language,
  theme,
  screenSize,
}) => {
  if (!isEditing || isOriginator) return null;

  const currentStatus = getCurrentUserRSVPStatus(selectedEvent);
  const statusLabel = currentStatus ? t[currentStatus] || currentStatus : t.noResponse;

  return (
    <>
      {/* Current RSVP Status */}
      <div
        style={{
          padding: screenSize.isMobile ? "12px 16px" : "16px 20px",
          borderRadius: screenSize.isMobile ? "10px" : "14px",
          background:
            theme === "dark"
              ? "rgba(16, 185, 129, 0.1)"
              : "rgba(16, 185, 129, 0.05)",
          border: "2px solid rgba(16, 185, 129, 0.2)",
          marginBottom: screenSize.isMobile ? "16px" : "24px",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          flexDirection: language === "ar" ? "row-reverse" : "row",
        }}
      >
        <Check size={20} style={{ color: "#2e7cba" }} />
        <div style={{ textAlign: language === "ar" ? "right" : "left" }}>
          <div
            style={{
              fontWeight: "600",
              color: theme === "dark" ? "#fff" : "#1a1a1a",
              marginBottom: "4px",
              fontSize: screenSize.isMobile ? "14px" : "16px",
            }}
          >
            {t.yourCurrentRSVP}: {statusLabel}
          </div>
          {!currentStatus && (
            <div
              style={{
                fontSize: screenSize.isMobile ? "12px" : "14px",
                color:
                  theme === "dark"
                    ? "rgba(255,255,255,0.7)"
                    : "rgba(26,26,26,0.6)",
              }}
            >
              {t.updateResponse}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default RSVPSection;
